/* TODO: t() */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Component } from 'react';
import { View, StyleSheet } from 'react-native';

import Radio from '../uiold/Radio';
import { Alert, Button, Modal, Text, TextInput } from '../uiold';
import { themeColors } from '../uiold/Constants';
import { VendorLocationsOptions } from '../EmbedInfo';

import { isValidCoordinate, isValidSize } from './OptionDialogHelpers';

type Props = {
  onHide: () => void;
  isModalVisible: boolean;
  renderVendorLocationsBlock: (arg0: VendorLocationsOptions) => React.ReactNode;
};

type State = {
  error: Error | null | undefined;
  defaultCenter: {
    lat: string;
    lng: string;
  };
  defaultZoom: number;
  mapHeight: string;
  showListView: boolean;
  defaultCenterValidity: {
    lat: boolean;
    lng: boolean;
  };
  mapHeightValidity: boolean;
};

let minZoom = 0;
let maxZoom = 30;

export default class OptionDialog extends Component<Props, State> {
  state: State = {
    error: null,
    defaultCenter: {
      lat: '-6.2596',
      lng: '106.6232359',
    },
    defaultCenterValidity: {
      lat: true,
      lng: true,
    },
    defaultZoom: (maxZoom - minZoom) / 2,
    mapHeight: '200',
    mapHeightValidity: true,
    showListView: true,
  };

  render() {
    let { isModalVisible } = this.props;
    return (
      <Modal
        isVisible={isModalVisible}
        onClose={this._onHide}
        title="Vendor Locations"
      >
        <Modal.Body>
          {this._renderError()}
          {this._renderCoordinate()}
          {this._renderZoom()}
          {this._renderMapHeight()}
          {this._renderListView()}
          {this._renderEmbedCode()}
        </Modal.Body>
        <Modal.Footer>
          <Button title="Done" onPress={this._onHide} isPrimary />
        </Modal.Footer>
      </Modal>
    );
  }

  _coorChange = (type: 'lat' | 'lng', value: string) => {
    this.setState({
      defaultCenter: {
        ...this.state.defaultCenter,
        [type]: value,
      },
      defaultCenterValidity: {
        ...this.state.defaultCenterValidity,
        [type]: isValidCoordinate(value),
      },
    });
  };

  _zoomChange = (val: string) => {
    this.setState({ defaultZoom: parseInt(val, 10) });
  };

  _mapHeightChange = (value: string) => {
    this.setState({
      mapHeight: value,
      mapHeightValidity: isValidSize(value),
    });
  };

  _toggleListView = () => {
    this.setState({ showListView: !this.state.showListView });
  };

  _onHide = () => {
    if (this.props.onHide) {
      this.props.onHide();
    }
  };

  _renderError = () => {
    if (!this.state.error) {
      return;
    }
    return (
      <Alert
        type="error"
        onDismiss={this._errorDismiss}
        text={this.state.error.message}
      />
    );
  };

  _errorDismiss = () => {
    this.setState({ error: null });
  };

  _renderCoordinate = () => {
    return (
      <View style={[styles.section, styles.sectionBorder]}>
        <Text style={styles.sectionName}>Default Center</Text>
        <View style={styles.coordinate}>
          <TextInput
            value={this.state.defaultCenter.lat}
            onChangeText={(value) => {
              this._coorChange('lat', value);
            }}
            placeholder="Latitude"
            style={styles.coordinateInput}
          />
          <TextInput
            value={this.state.defaultCenter.lng}
            onChangeText={(value) => {
              this._coorChange('lng', value);
            }}
            placeholder="Longitude"
          />
        </View>
      </View>
    );
  };

  _renderZoom = () => {
    let { defaultZoom } = this.state;
    return (
      <View style={[styles.section, styles.sectionBorder]}>
        <Text style={styles.sectionName}>Default Zoom</Text>
        <View style={styles.sectionContent}>
          <input
            style={{ marginHorizontal: 5 } as any}
            type="range"
            min={minZoom}
            max={maxZoom}
            step="1"
            defaultValue={defaultZoom}
            onInput={(event: any) => this._zoomChange(event.target.value)}
          />
          <View style={styles.coordinateScale}>
            <Text>{minZoom}</Text>
            {/* TODO: Check the design on how to show the current zoom level */}
            <Text>{defaultZoom}</Text>
            <Text>{maxZoom}</Text>
          </View>
        </View>
      </View>
    );
  };

  _renderMapHeight = () => {
    return (
      <View style={[styles.section, styles.sectionBorder]}>
        <Text style={styles.sectionName}>Map Height</Text>
        <View style={styles.sectionContent}>
          <TextInput
            value={this.state.mapHeight}
            onChangeText={this._mapHeightChange}
            placeholder="Height"
          />
        </View>
      </View>
    );
  };

  _renderListView = () => {
    return (
      <View style={[styles.section, styles.sectionBorder]}>
        <Text style={styles.sectionName}>Show List View</Text>
        <View style={[styles.sectionContent, styles.listRadio]}>
          <View style={styles.radioChild}>
            {/* TODO: Add FormField and htmlFor label */}
            <Radio
              name="listView"
              value={true}
              checked={!!this.state.showListView}
              onChange={this._toggleListView}
            />
            <Text>Yes</Text>
          </View>
          <View style={styles.radioChild}>
            <Radio
              name="listView"
              value={false}
              checked={!this.state.showListView}
              onChange={this._toggleListView}
            />
            <Text>No</Text>
          </View>
        </View>
      </View>
    );
  };

  _renderEmbedCode = () => {
    let { renderVendorLocationsBlock } = this.props;
    let {
      defaultCenter,
      defaultZoom,
      showListView,
      mapHeight,
      defaultCenterValidity,
      mapHeightValidity,
    } = this.state;
    let options: VendorLocationsOptions = {
      defaultZoom,
      showListView,
    };

    if (defaultCenterValidity.lat && defaultCenterValidity.lng) {
      options = { ...options, defaultCenter };
    }

    if (mapHeightValidity) {
      options = { ...options, mapHeight };
    }

    return (
      <View style={styles.section}>
        <Text style={styles.sectionName}>Embed Code</Text>
        <View style={styles.sectionContent}>
          {renderVendorLocationsBlock(options)}
        </View>
      </View>
    );
  };
}

let styles = StyleSheet.create({
  section: {
    paddingHorizontal: 20,
    paddingVertical: 16,
  },
  sectionBorder: {
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderColor: themeColors.grey,
  },
  sectionName: {
    fontWeight: '500',
  },
  sectionContent: {
    paddingVertical: 10,
  },
  coordinate: {
    flexDirection: 'row',
    paddingVertical: 10,
  },
  coordinateInput: {
    marginRight: 20,
  },
  coordinateScale: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  listRadio: {
    flexDirection: 'row',
  },
  radioChild: {
    margin: 5,
    paddingRight: 10,
    flexDirection: 'row',
  },
});
